import { useEffect, useState } from "react";

import { Modal } from "@mui/material";
import ImageNotSupportedIcon from "@mui/icons-material/ImageNotSupported";

import { httpClient } from "./config/api";
import { Box } from "@mui/system";

const ModalImagenes = ({ modalImagenes, setModalImagenes, funcionFondo, desactivarFondo, virtualBackgroundEnabled }) => {
  const [imagenes, setImagenes] = useState([]);

  const aplicarFondo = (url) => {
    if (virtualBackgroundEnabled) {
      desactivarFondo();
    } else {
      funcionFondo(url);
    }
  };

  const obtenerImagenes = async () => {
    const response = await httpClient.get("/agora/get/fondos");
    console.log(response.data);
    setImagenes(response.data.data);
  };

  useEffect(() => {
    obtenerImagenes();
  }, []);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "30%",
    backgroundColor: "white",
    padding: "10px",
  };

  return (
    <Modal
      open={modalImagenes}
      onClose={() => setModalImagenes(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box style={{ ...style }}>
        <div id="modal-modal-title" variant="h6" component="h2" style={{ margin: 10, marginBottom: 25, fontWeight: 600 }}>
          ELIGE UNA IMAGEN
        </div>
        <div id="modal-modal-description">
          <div style={{ flexWrap: "wrap", display: "flex", justifyContent: "space-around" }}>
            <div
              className="Contenedor-imaa"
              style={{ display: "flex", justifyContent: "center", alignItems: "center", border: "2px solid #ccc" }}
              key="noImage"
              onClick={() => {
                desactivarFondo();
                setModalImagenes(false);
              }}
            >
              <ImageNotSupportedIcon style={{ fontSize: 40 }} />
            </div>
            {imagenes.map((imagen) => (
              <div className="Contenedor-imaa" key={imagen}>
                <img
                  className="imaa"
                  src={imagen}
                  alt={imagen}
                  onClick={() => {
                    funcionFondo(imagen);
                    setModalImagenes(false);
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default ModalImagenes;
